import { Preferences } from '@capacitor/preferences';
// Capacitor Preferences works on web too (localStorage-backed), so we can use it
// uniformly and avoid a hand-rolled fallback.
export async function getItem(key) {
  const { value } = await Preferences.get({ key });
  return value ?? null;
}
export async function setItem(key, value) {
  await Preferences.set({ key, value });
}
export async function removeItem(key) {
  await Preferences.remove({ key });
}
